import { render, staticRenderFns } from "./PrelimsRoundScoreParticipants.vue?vue&type=template&id=b02a8a46&scoped=true"
import script from "./PrelimsRoundScoreParticipants.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrelimsRoundScoreParticipants.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrelimsRoundScoreParticipants.vue?vue&type=style&index=0&id=b02a8a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02a8a46",
  null
  
)

export default component.exports